import { useTranslation } from 'react-i18next';

import {
    Body1,
    Flex,
    IconPrescription,
} from '@myphx-engineering/phx-design-system';

export type RxForUserProps = {
    patient: {
        firstName?: string;
        fullName?: string;
        lastName?: string;
    };
};

export const RxForUser = ({ patient }: RxForUserProps) => {
    const { t } = useTranslation();

    const { firstName, fullName, lastName } = patient;

    const name = fullName ? fullName : `${firstName} ${lastName}`;

    return (
        <Flex align="center" gap="xxs">
            <IconPrescription color="gray" />
            <Body1>{t('shoppingHeader.forUser', { name })}</Body1>
        </Flex>
    );
};
